"use client";

import { useMutation } from "@apollo/client";
import {
  ModalButtons,
  Select,
  SelectContent,
  SelectField,
  SelectItem,
  SelectTrigger,
  SelectValue,
  Textarea,
} from "components/ui/v2";
import { gqlUser } from "gql";
import { IUserNotifyInput } from "gql/User/mutations";
import useTranslation from "next-translate/useTranslation";
import { useState } from "react";
import toast from "react-hot-toast";
import type { FormV2Props } from "../form-v2-props";

export const NOTIFY_GROUP_FORM_ID = "notify-group-form";

export interface NotifyGroupModalContentV2Props extends FormV2Props {
  hideFooter?: boolean;
  formId?: string;
}

export function NotifyGroupModalContentV2({
  onClose,
  hideHeader = true,
  hideFooter = false,
  formId = NOTIFY_GROUP_FORM_ID,
}: NotifyGroupModalContentV2Props) {
  const { t } = useTranslation("common");
  const [selectedOption, setSelectedOption] = useState<string>("all");
  const [text, setText] = useState<string>("");

  const options = [
    { label: t("Todos"), value: "all" },
    { label: t("Sin certificaciones"), value: "without-certifications" },
    { label: t("Han marcado Other"), value: "with-other-type" },
  ];

  const [userNotify, { loading }] = useMutation<{
    userNotifyInput: IUserNotifyInput;
  }>(gqlUser.mutations.USER_NOTIFY, {
    onCompleted: () => {
      onClose?.();
      toast.success(t("Notificación enviada correctamente"));
    },
    onError: ({ message }) => {
      toast.error(message);
    },
  });

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    userNotify({
      variables: {
        userNotifyInput: {
          from: t("Certificaciones"),
          text,
          type: selectedOption,
        },
      },
    });
  };

  return (
    <form id={formId} onSubmit={handleSubmit} className="flex flex-col gap-2">
      {!hideHeader && (
        <div>
          <h3 className="text-[13px] font-semibold text-slate-900 dark:text-zinc-100 sm:text-[15px]">
            {t("Notificación")}
          </h3>
          <p className="mt-1 text-[9px] text-slate-500 dark:text-zinc-400">
            {t(
              "Esta notificación será enviada a toda la organización en caso de seleccionar ese criterio"
            )}
          </p>
        </div>
      )}
      <label className="text-left font-semibold">{t("Criterio")}</label>
      <Select value={selectedOption} onValueChange={setSelectedOption}>
        <SelectField>
          <SelectTrigger>
            <SelectValue />
          </SelectTrigger>
        </SelectField>
        <SelectContent>
          {options.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      <label className="text-left font-semibold">{t("Mensaje")}</label>
      <Textarea
        value={text}
        onChange={(event) => setText(event.target.value)}
        rows={4}
        placeholder={t("Ingresa tu mensaje acá")}
      />
      <span className="text-[9px] text-red-400">
        <ol>
          <li>{t("Se notificará a los usuarios afectados")}</li>
          <li>{t("Usar con precaución")}</li>
        </ol>
      </span>
      {!hideFooter ? (
        <ModalButtons
          loading={loading}
          onCancel={onClose}
          cancelLabel={t("Cerrar")}
          submitLabel={t("Notificar ahora")}
        />
      ) : null}
    </form>
  );
}
